/* eslint-disable react/react-in-jsx-scope */
import { useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from '@reach/router';

const PageVisitorsHistory = ({
  component: Component, user, pageName, ...rest
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    axios.post('/api/visitorHistory/saveVisit', {
      PageCode: pageName !== ' ' ? pageName : window.location.pathName,
      EmployeeId: user.employeeId,
      TimeStamp: new Date().toISOString(),
    }).catch(console.error);
  }, [location.pathname, navigate]);

  return <Component user={user} {...rest} />;
};

export default PageVisitorsHistory;
